/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React from 'react';
import Block from 'wfui-digital-core/es/Block';

var SessionInactive = function SessionInactive() {
  return /*#__PURE__*/React.createElement(Block, {
    p: "s"
  }, "You have been logged out.");
};

export default SessionInactive;